<template>
  <div>
    <div  v-for="item in motivationList" :key="item.id">
      <p class="nd_p_text14 mb-4">{{item[`name_${$i18n.locale}`]}}</p>
    <p class="nd_p_text16 nd_font_weight500">© {{item.authorName}}</p>
    </div>

  </div>
</template>

<script>
// import { $i18n } from 'vue-i18n';
export default {
name: 'MotivationList',
  data() {
    return{
      motivationList: [],
      editLang: '',
      newList: []
    }
  },
  mounted() {
    this.getAllNodes();
  },
methods: {
  // getTranslatedName(item) {
  //   const locale = $i18n.locale;
  //
  //   const translatedName = item[`name_${locale}`];
  //
  //   return translatedName || item.name;
  // },
  getAllNodes() {
    this.$api
        .get('motivation',)
        .then(response => {
          this.motivationList = response.data.data;
        });
  },
  mounted(){
    this.changeLange();

  }
},
}
</script>

<style lang="scss" scoped>

</style>
